import apiClient from "./client.js";

/**
 * Register a new account with email and password.
 * Returns a message — the user must verify their email before they can log in.
 */
export async function registerWithPassword(email, password, fullName, plan = null, invitationToken = null) {
  const body = { email, password, full_name: fullName || null };
  if (plan) body.plan = plan;
  if (invitationToken) body.invitation_token = invitationToken;
  const response = await apiClient.post("/auth/register", body);
  return response.data.data;
}

/**
 * Verify email address using the token from the verification email.
 * Returns a session on success (auto-login).
 */
export async function verifyEmail(token) {
  const response = await apiClient.post("/auth/verify-email", { token });
  return response.data.data;
}

/**
 * Resend the email verification link for an unverified account.
 */
export async function resendVerification(email) {
  await apiClient.post("/auth/resend-verification", { email });
}

/**
 * Authenticate with email and password.
 *
 * @param {string} email
 * @param {string} password
 * @returns {Promise<{access_token: string, token_type: string}>}
 */
export async function loginWithPassword(email, password) {
  const response = await apiClient.post("/auth/login", { email, password });
  return response.data.data;
}

export async function completeLoginChallenge(token, code) {
  const response = await apiClient.post("/auth/login/challenge", { token, code });
  return response.data.data;
}

export async function requestPasswordReset(email) {
  await apiClient.post("/auth/forgot-password", { email });
}

export async function resetPassword(token, password) {
  await apiClient.post("/auth/reset-password", { token, password });
}

export async function refreshSession() {
  const response = await apiClient.post("/auth/refresh");
  return response.data.data;
}

/**
 * Invalidate the session server-side (clears the httpOnly refresh cookie).
 */
export async function logoutRequest() {
  await apiClient.post("/auth/logout");
}
